module.exports = __webpack_public_path__ + "static/img/big-2.0a504f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/backgroundImg/big-2.png
// module id = hMEE
// module chunks = 64